// features/studysets/api/use-remove-from-folder.ts

import { useMutation, useQueryClient } from "@tanstack/react-query";
import { toast } from "sonner";
import { useTRPC } from "@/trpc/client";

export function useRemoveFromFolder() {
  const queryClient = useQueryClient();
  const trpc = useTRPC();

  return useMutation(
    trpc.folders.removeStudySet.mutationOptions({
      onSuccess: (_, { id: folderId }) => {
        toast.success("Removed from folder");
        queryClient.invalidateQueries({
          queryKey: trpc.folders.getUserFolders.queryKey(),
        });
        queryClient.invalidateQueries({
          queryKey: trpc.folders.getStudySets.queryKey({ id: folderId }),
        });
      },
      onError: () => {
        toast.success("Failed to remove study set from folder");
      },
    }),
  );
}
